import { useTranslation } from "react-i18next";

import { Divider } from "@mui/material";
import { FormikProps } from "formik";

import { FieldPath } from "../../../../../../../../../../formik/FormikField.types";
import { FormikAutocompleteSelect } from "../../../../../../../../../../formik/formik-autocomplete/FormikAutocompleteSelect";
import { AssetIncomeFormValues } from "../../../../../../IncomeView.types";
import { useIncomeTypes } from "../../../../../../hooks/useIncomeTypes";

interface Props {
  formik: FormikProps<AssetIncomeFormValues>;
  path: FieldPath<AssetIncomeFormValues>;
}

export function IncomeTypeSelect({ formik, path }: Props) {
  const { t } = useTranslation();
  const { options, groupOf, isMainGroup } = useIncomeTypes();

  return (
    <FormikAutocompleteSelect
      formik={formik}
      path={path}
      label={t("clients.client.debtSettlement.assetInventory.incomeTab.entry.incomeType")}
      options={options}
      groupBy={groupOf}
      renderGroup={(params) => (
        <li key={params.key}>
          {!isMainGroup(params.group) && <Divider component="div" role="separator" aria-hidden />}
          <ul style={{ padding: 0 }}>{params.children}</ul>
        </li>
      )}
    />
  );
}
